import { css } from 'lit';

export const ButtonClearStyle = css`
.lds-button-base,
.lds-button-clear-style {
  padding: 0;
  margin: 0;
  font-family: var(--lds-typography-font-family);
  font-size: inherit;
  font-weight: inherit;
  line-height: inherit;
  color: inherit;
  cursor: pointer;
  background: none;
  border: 0;
}
`;
export default ButtonClearStyle;
